import type { ParsedUrlQuery } from 'querystring';

type Props = {
  // Example: you can get it from useRouter ( router.query )
  query?: ParsedUrlQuery | null;
  paramsToRemove?: string[];
};
const removeQueryParams = ({ query, paramsToRemove }: Props) => {
  if (!query) {
    return {};
  }

  if (!paramsToRemove) {
    return query;
  }
  const updatedQuery = Object.keys(query).reduce((acc, key) => {
    if (!paramsToRemove.includes(key)) {
      acc[key] = query[key];
    }
    return acc;
  }, {} as ParsedUrlQuery);
  return updatedQuery;
};

export default removeQueryParams;
